import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';

export function redirectToLogin() {
  if (isSDK()) {
    const sdkLoginPagePath = `campaign/sdk?RURL=${encodeURIComponent(window.location.href)}&sdksignup=false`;
    window.location.href = `${window.location.protocol}//${window.location.host}/${sdkLoginPagePath}`;
  } else {
    window.location.href = `${window.location.protocol}//${window.location.host}/default.aspx?reason=1&msg=sessionexpired`;
  }
}

export function handleAjaxAuthFailure(data, requestUrl) {
  if (data && data.Error === '401') {
    if (requestUrl && requestUrl.indexOf(window.location.host) > -1) {
      redirectToLogin();
      return false;
    }
  }
  return true;
}
